import { RadioButtonWithLabelOption } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { RevisionHistorySectionProps } from './RevisionHistorySection';
import { RevisionsInput } from './RevisionsInput';

export const CONTENT_VERSION_LIMIT_ENABLED_FIELD = 'settings.contentVersionLimitEnabled';

export function RevisionHistoryOptions(props: RevisionHistorySectionProps) {
  const buttons = React.useMemo(() => getButtons(props), [props]);

  return (
    <FormikRadioButtonGroup buttonList={buttons}
                            testId={'revision-history-options'}
                            className={settingsRadioButtonItemHeight}
                            name={CONTENT_VERSION_LIMIT_ENABLED_FIELD}
                            aria-label={Messages.versionHistorySettingsGroupName()}
    />
  );
}

function getButtons(props: RevisionHistorySectionProps): RadioButtonWithLabelOption<boolean>[] {
  return [{
    testId: 'revision-unlimited-radio-button',
    label: Messages.unlimited(),
    value: false
  }, {
    testId: 'revision-limit-radio-button',
    label: <RevisionsInput {...props}/>,
    value: true
  }];
}
